export const CHARACTER = 'char'
export const WORD = 'word'
